import { Routes } from '@angular/router';
import { AuthGuard } from './guard/AuthGuard';

export const routes: Routes = [
  // { path: '', redirectTo: 'landing-page', pathMatch:'full' },
  { path:'',
  canActivate:[AuthGuard],
  data:{roles:['NEXTGENAPPS']} ,
  loadChildren:()=>
  import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule) },
   {path:'dashboard',
   canActivate:[AuthGuard],
   data:{roles:['NEXTGENAPPS']} ,
   loadChildren:()=>
   import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule),
  },
  {path:'landing-page',
  canActivate:[AuthGuard],
  data:{roles:['NEXTGENAPPS']} ,
  loadChildren:()=>
  import('./pages/general/modules/landing/landing.module').then(root=>root.LandingModule)
 }
    // { path: "login", component: DashboardComponent, 
    // canActivate: [AuthGuard], data: { roles: ["NEXTGENAPPS"]} },

];
